import { InfoTermsAction } from "Pages/InfoTermsPage/Redux/actions";

export interface IInfoTerms {
  isFetching: boolean;
  isFetchFailed: boolean;
  content: Julius.Website.TermsPageViewModel;
};

const initialInfoTerms: IInfoTerms = {
  isFetching: false,
  isFetchFailed: false,
  content: null,
};

function infoTerms(
  state: IInfoTerms = initialInfoTerms, 
  action: InfoTermsAction,
  ): IInfoTerms {

  switch (action.type) {
    case 'SET_IS_FETCHING_TERMS_CONTENT':
      return {
        ...state,
        isFetching: true,
        isFetchFailed: false,
      };

    case 'SET_FETCH_TERMS_CONTENT_FAILED':
      return {
        ...state,
        isFetching: false,
        isFetchFailed: true,
      };

    case 'SET_TERMS_CONTENT':
      return {
        ...state,
        content: action.content,
        isFetching: false,
        isFetchFailed: false,
      };

    default:
      return state;
  }
}

export default infoTerms;


// WEBPACK FOOTER //
// ./src/pages/InfoTermsPage/Redux/reducer.tsx